ScoreTrekBattle.Tournament.TreeView = (function () {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            liveStatus: null,
            $wrapper: null,
            $tree: null,
            dialog: null,
            zoom: {
                base: 1,
                current: 1,
                last: 1,
                min: 1,
                max: 1
            },
            pan: {
                step: 100
            },
            drag: {
                isActive: false,
                start: {
                    x: 0,
                    y: 0
                },
                pan: {
                    x: 0,
                    y: 0
                },
                timer: null
            }
        };
    }
    resetStatus();

    function renderColumns() {
        return new Promise(function (resolve) {
            let koRounds, columns, currentNumber, columnPromises, prevPartitionsCount, currentColumn;

            koRounds = [];
            columns = [];

            STATUS.liveStatus.rounds.forEach(round => {
                if (round.type === 'knockout') {
                    koRounds.push(round);
                }
            });

            koRounds.sort((roundA, roundB) => {
                return (roundA.order < roundB.order) ? -1 : ((roundA.order > roundB.order) ? 1 : 0);
            });

            currentNumber = 0;
            currentColumn = null;

            koRounds.forEach(round => {
                let roundKey;

                roundKey = Math.floor(round.order);

                if (roundKey !== currentNumber) {
                    currentColumn = [[], []];
                    columns.push(currentColumn);
                    currentNumber = roundKey;
                }

                currentColumn[((round.index >= 0) && (round.partition !== 'B')) ? 0 : 1].push(round);
            });

            columnPromises = [];

            prevPartitionsCount = 1;

            columns.forEach(column => {
                if (column[1].length === 0) {
                    column.pop();
                }
               
                columnPromises.push(renderColumn(column, prevPartitionsCount));

                prevPartitionsCount = column.length;
            });

            Promise.all(columnPromises).then(resolve);
        });
    }

    function renderColumn(column, prevPartitionsCount) {
        return new Promise(function (resolve) {
            let $column, isSplit, partitionPromises;

            $column = $('<div>').addClass('tree-column');

            partitionPromises = [];

            isSplit = (column.length > prevPartitionsCount);
            
            column.forEach(partition => {
                partitionPromises.push(renderPartition(partition, isSplit));
            });


            Promise.all(partitionPromises).then($partitions => {
                let maxMatches;

                maxMatches = 0;
                $partitions.forEach($partition => {
                    maxMatches = Math.max(maxMatches, $partition.find('.tree-match').length);
                });

                $column.attr('data-max-matches', maxMatches).append($partitions);
                resolve($column);
            });
        });
    }

    function renderPartition(partition, isSplit) {
        return new Promise(function (resolve) {
            let $partition, roundPromises;

            $partition = $('<div>').addClass('tree-partition');

            roundPromises = [];

            partition.forEach(round => {
                let isWinnerSplit, isLoserSplit;

                isWinnerSplit = isSplit && ((round.subType === 'doubleWinner') || (round.partition === 'A'));
                isLoserSplit = isSplit && ((round.subType === 'doubleLoser') || (round.partition === 'B'));

                if (round.isRandomDraw) {
                    roundPromises.push(renderRoundIcon('<i class="fa-solid fa-dice"></i>', 'blue'));
                } else if (isWinnerSplit) {
                    roundPromises.push(renderRoundIcon('<i class="fa-solid fa-arrow-trend-up"></i>', 'soft-green'));
                } else if (isLoserSplit) {
                    roundPromises.push(renderRoundIcon('<i class="fa-solid fa-arrow-trend-down"></i>', 'soft-red'));
                }
                roundPromises.push(renderRound(round));

                isSplit = false;
            });

            Promise.all(roundPromises).then($rounds => {
                $partition.append($rounds);
                resolve($partition);
            });
        });
    }

    function renderRound(round) {
        return new Promise(function (resolve) {
            let $round, gamePromises;

            $round = $('<div>').addClass('tree-round');

            gamePromises = [];

            round.games.forEach(game => {
                gamePromises.push(renderGame(STATUS.liveMap.GAMES[game.id] || game));
            });

            Promise.all(gamePromises).then($games => {
                $round.append($games);
                resolve($round);
            });

        });
    }

    function renderRoundIcon(icon, color) {
        return new Promise(function (resolve) {
            resolve($('<div>').addClass(`tree-roundIcon color-${color}`).html(icon));
        });
    }

    function renderGame(game) {
        return new Promise(function (resolve) {
            ScoreTrekBattle.Template.render('tournament/tree/match', {
                game: game
            }).then(gameView => {
                let $game;
                $game = gameView.$view;
                ScoreTrekBattle.Tournament.Live.renderGameData(game, $game).then(() => {
                    resolve($game);
                });
            });
        });
    }

    function markGame(gameId) {
        let game, $game, isMarked;

        if (!STATUS.$tree) {
            return;
        }

        game = STATUS.liveMap.GAMES[gameId];

        if (!game) {
            return;
        }

        $game = STATUS.$tree.find(`[data-game-id="${gameId}"]`);

        isMarked = !$game.hasClass('isMarked');

        unmarkGames();

        if (!isMarked) {
            return;
        }

        $game.addClass('isMarked');
        markRelatedGames(game, ['winnerTo', 'loserTo'], true);
        markRelatedGames(game, ['team1From', 'team2From'], true);
    }

    function unmarkGames() {
        if (!STATUS.$tree) {
            return;
        }

        STATUS.$tree.find('.tree-match').removeClass('isMarked');
    }

    function markRelatedGames(game, keys, force) {
        let $game;

        if (!game || !STATUS.$tree) {   
            return;
        }

        $game = STATUS.$tree.find(`[data-game-id="${game.id}"]`);

        if ($game.hasClass('isMarked') && !force) {
            return;
        }

        $game.addClass('isMarked');

        keys.forEach(key => {
            let keyParts, relatedGameId, relatedGame;

            if (game.isRandomDraw && key === 'team2From') {
                return;
            }

            keyParts = String(game[key]).split(':');

            relatedGameId = keyParts.shift();
            
            if (!relatedGameId) {
                return;
            }

            relatedGame = STATUS.liveMap.GAMES[relatedGameId];

            if (relatedGame.isRandomDraw && (keyParts.shift() === 'team2')) {
                return;
            }

            markRelatedGames(relatedGame, keys);
        });
    }

    function onShow() {
        initSize();
        initZoom();
        initPan();
    }

    function onResize() {
        initZoom();
        initPan();
    }

    function initSize() {
        let teamMinWidth, $columns, depth, columnHeight, matchHeight, matchGap, matchRefCount;

        normalizeSize(STATUS.$wrapper, true);
        normalizeSize(STATUS.$tree, true);

        teamMinWidth = 0;
        STATUS.$tree.find('.tree-match-team').each(function () {
            teamMinWidth = Math.max(this.offsetWidth, teamMinWidth);
        });

        STATUS.$tree.get(0).style.setProperty('--team-min-width', `${teamMinWidth}px`);

        $columns = STATUS.$tree.find('.tree-column');

        columnHeight = 0;
        $columns.each(function () {
            columnHeight = Math.max(this.offsetHeight, columnHeight);
        });

        matchHeight = STATUS.$tree.find('.tree-match').first().height();
        matchGap = parseFloat(getComputedStyle(STATUS.$tree.find('.tree-round').first().get(0)).gap);

        depth = (STATUS.liveStatus.tournament.preset.preset.koSystem === 'double') ? -1 : 0;

        $columns.height(`${columnHeight}px`).each(function() {
            let hasDepth, roundOffsetY;

            depth++;
            hasDepth = (depth > 1);

            this.dataset.hasDepth = hasDepth ? 'yes' : 'no';
            this.dataset.depth = hasDepth ? depth : 1;
            this.style.height = `${columnHeight}px`;

            if (!hasDepth) {
                return;
            }

            matchRefCount = Math.pow(2, (depth - 1));
            roundOffsetY = 0.5 * (matchRefCount - 1) * (matchHeight + matchGap);

            this.style.setProperty('--round-offset-y', `${roundOffsetY}px`);
        });
    }

    function initZoom() {
        if (!STATUS.$wrapper || !STATUS.$tree) {
            return;
        }

        normalizeSize(STATUS.$wrapper);
        normalizeSize(STATUS.$tree);

        STATUS.zoom.base = Math.min(1, (STATUS.$wrapper.width() / STATUS.$tree.outerWidth()), (STATUS.$wrapper.height() / STATUS.$tree.outerHeight()));

        STATUS.zoom.current = 1;
        STATUS.zoom.max = 1.5 * Math.max(1, (1 / STATUS.zoom.base));

        setZoom();
    }

    function initPan() {
        if (!STATUS.$wrapper || !STATUS.$tree) {
            return;
        }

        STATUS.pan.step = Math.round(Math.min(window.innerWidth, window.innerHeight) / 10);
    }

    // focused zoom helpers
    function getWrapperClientPoint(wrapperEl, clientX, clientY) {
        let r, p;
        r = wrapperEl.getBoundingClientRect();
        p = { x: clientX - r.left, y: clientY - r.top };
        return p;
    }

    function clamp(val, min, max) {
        let v;
        v = Math.max(min, Math.min(max, val));
        return v;
    }

    function zoomAt(focusX, focusY, targetZoomCurrent) {
        let wrapperEl, prevCurrent, sOld, sNew, contentX, contentY, newSL, newST, maxSL, maxST;

        if (!STATUS.$wrapper || !STATUS.$tree) {
            return;
        }

        wrapperEl = STATUS.$wrapper.get(0);

        prevCurrent = STATUS.zoom.current;
        STATUS.zoom.current = Math.max(STATUS.zoom.min, Math.min(STATUS.zoom.max, targetZoomCurrent));

        sOld = prevCurrent * STATUS.zoom.base;
        sNew = STATUS.zoom.current * STATUS.zoom.base;

        contentX = (wrapperEl.scrollLeft + focusX) / sOld;
        contentY = (wrapperEl.scrollTop + focusY) / sOld;

        STATUS.$tree.get(0).style.setProperty('--scale', sNew);

        newSL = contentX * sNew - focusX;
        newST = contentY * sNew - focusY;

        maxSL = wrapperEl.scrollWidth - wrapperEl.clientWidth;
        maxST = wrapperEl.scrollHeight - wrapperEl.clientHeight;

        wrapperEl.scrollLeft = clamp(newSL, 0, Math.max(0, maxSL));
        wrapperEl.scrollTop  = clamp(newST, 0, Math.max(0, maxST));

        updateIndicator();
    }

    function setZoom() {
        STATUS.zoom.current = Math.max(STATUS.zoom.min, Math.min(STATUS.zoom.max, STATUS.zoom.current));
        STATUS.$tree.get(0).style.setProperty('--scale', STATUS.zoom.current * STATUS.zoom.base);
        updateIndicator();
    }

    function setPan() {
        STATUS.$wrapper.scrollLeft(STATUS.pan.x);
        STATUS.$wrapper.scrollTop(STATUS.pan.y);
    }

    function navigatePan(pageX, pageY) {
        let indicatorWrapperOffset, newIndicatorLeft, newIndicatorTop;
        
        if (!STATUS.$indicator || !STATUS.$indicatorWrapper || !STATUS.$wrapper) {
            return;
        }

        indicatorWrapperOffset = STATUS.$indicatorWrapper.offset();

        newIndicatorLeft = Math.max(0, (100 * (pageX - indicatorWrapperOffset.left - (0.5 * STATUS.$indicator.outerWidth())) / STATUS.$indicatorWrapper.width()));
        newIndicatorTop = Math.max(0, (100 * (pageY - indicatorWrapperOffset.top - (0.5 * STATUS.$indicator.outerHeight())) / STATUS.$indicatorWrapper.height()));

        STATUS.$wrapper.scrollLeft(STATUS.$wrapper.get(0).scrollWidth * (newIndicatorLeft / 100));
        STATUS.$wrapper.scrollTop(STATUS.$wrapper.get(0).scrollHeight * (newIndicatorTop / 100));
    }
        
    function updateIndicator() {
        let indicatorStyle, treeWidth, treeHeight;

        if (!STATUS.$indicator || !STATUS.$indicatorWrapper || !STATUS.$tree || !STATUS.$wrapper) {
            return;
        }

        STATUS.$indicatorWrapper.get(0).style.setProperty('--indicator-ratio', `${STATUS.$tree.outerWidth() / STATUS.$tree.outerHeight()}`);

        indicatorStyle = STATUS.$indicator.get(0).style;

        treeWidth = STATUS.$tree.outerWidth() * STATUS.zoom.current * STATUS.zoom.base;
        treeHeight = STATUS.$tree.outerHeight() * STATUS.zoom.current * STATUS.zoom.base;

        indicatorStyle.setProperty('--indicator-width', `${Math.min(100, (100 * STATUS.$wrapper.width() / treeWidth))}%`);
        indicatorStyle.setProperty('--indicator-height', `${Math.min(100, (100 * STATUS.$wrapper.height() / treeHeight))}%`);

        indicatorStyle.setProperty('--indicator-x', `${Math.min(100, (100 * STATUS.$wrapper.scrollLeft() / treeWidth))}%`);
        indicatorStyle.setProperty('--indicator-y', `${Math.min(100, (100 * STATUS.$wrapper.scrollTop() / treeHeight))}%`);
    }

    function normalizeSize($element, resetTeamMinWidth) {
        let elementStyle;
        if (!$element || !$element.length) {
            return;
        }

        elementStyle = $element.get(0).style;

        elementStyle.removeProperty('--scale');

        if (resetTeamMinWidth) {
            elementStyle.removeProperty('--team-min-width');
        }

        $element.css({
            width: '',
            height: '',
        });

        $element.css({
            width: `${2 * Math.floor($element.outerWidth() / 2)}px`,
            height: `${2 * Math.floor($element.outerHeight() / 2)}px`
        });
    }

    function onClose() {
        resetStatus();
    }

    function getDistance(touch1, touch2) {
        let dx, dy;
        dx = touch2.clientX - touch1.clientX;
        dy = touch2.clientY - touch1.clientY;
        return Math.hypot(dx, dy);
    }

    function addEventListeners() {
        let wrapper, initialDistance, pinchCenter, startZoomCurrent;

        wrapper = STATUS.$wrapper.get(0);

        wrapper.addEventListener('wheel', function (event) {
            if (!STATUS.$tree) {
                return;
            }

            if (!event.ctrlKey) {
                return; // only zoom with ctrl + wheel
            }

            event.preventDefault();
            event.stopPropagation();

            let pt, step, target;
            pt = getWrapperClientPoint(wrapper, event.clientX, event.clientY);
            step = 0.1;
            target = (event.deltaY < 0) ? (STATUS.zoom.current + step) : (STATUS.zoom.current - step);

            zoomAt(pt.x, pt.y, target);
        });

        wrapper.addEventListener('mousedown', function(event) {
            if (event.which !== 1) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            startDrag(event.clientX, event.clientY);

        });
        
        wrapper.addEventListener('mousemove', function(event) {
            if (!STATUS.drag.isActive) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            moveDrag(event.clientX, event.clientY);
        });
        
        wrapper.addEventListener('mouseup', function(event) {
            stopDrag();
        });

        wrapper.addEventListener('touchstart', function (event) {
            if (event.touches.length === 2) {
                let t1, t2, cx, cy;

                t1 = event.touches[0];
                t2 = event.touches[1];
                initialDistance = getDistance(t1, t2);

                cx = (t1.clientX + t2.clientX) / 2;
                cy = (t1.clientY + t2.clientY) / 2;
                pinchCenter = getWrapperClientPoint(wrapper, cx, cy);
                startZoomCurrent = STATUS.zoom.current;
            }
        });

        wrapper.addEventListener('touchmove', function (event) {
            let currentDistance, scale, zoomLevel;

            if ((event.touches.length === 2) && (initialDistance !== null)) {
                event.preventDefault();

                currentDistance = getDistance(event.touches[0], event.touches[1]);
                scale = currentDistance / initialDistance;

                zoomLevel = startZoomCurrent * scale;

                zoomAt(pinchCenter.x, pinchCenter.y, zoomLevel);
            }
        }, { passive: false });

        wrapper.addEventListener('touchend', function (event) {
            if (event.touches.length < 2) {
                STATUS.zoom.last = STATUS.zoom.current;
                initialDistance = null;
                pinchCenter = null;
                startZoomCurrent = null;
            }
        });

        STATUS.$indicatorWrapper.on('dblclick', function() {
            ScoreTrekBattle.Event.trigger('action.treeView.zoom', [{}, 'reset']);
        }).on('mousedown mousemove', function(event) {
            if (!(event.buttons & 1)) {
                return;
            }
            navigatePan(event.pageX, event.pageY);
        }).on('touchstart touchmove', function(event) {
            if (event.touches.length !== 1) {
                return;
            }
            navigatePan(event.touches[0].pageX, event.touches[0].pageY);
        });
    }

    function startDrag(startX, startY) {
        if (!STATUS.$tree) {
            return;
        }

        STATUS.drag.isActive = true;
        STATUS.drag.start.x = startX;
        STATUS.drag.start.y = startY;
        STATUS.drag.pan.x = STATUS.$wrapper.scrollLeft();
        STATUS.drag.pan.y = STATUS.$wrapper.scrollTop();

        clearTimeout(STATUS.drag.timer);
    }

    function moveDrag(currentX, currentY) {
        let deltaX, deltaY;

        if (!STATUS.$tree) {
            return;
        }

        deltaX = (currentX - STATUS.drag.start.x);
        deltaY = (currentY - STATUS.drag.start.y);

        if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) > 10) {
            STATUS.$tree.addClass('isDragging');
        }

        STATUS.pan.x = (STATUS.drag.pan.x - deltaX);
        STATUS.pan.y = (STATUS.drag.pan.y - deltaY);

        setPan();
    }

    function stopDrag() {
        STATUS.drag.isActive = false;
        STATUS.drag.start.x = 0;
        STATUS.drag.start.y = 0;
        STATUS.drag.pan.x = 0;
        STATUS.drag.pan.y = 0;

        clearTimeout(STATUS.drag.timer);
        STATUS.drag.timer = setTimeout(() => {
            if (!STATUS.$tree) {
                return;
            }
            STATUS.$tree.removeClass('isDragging');
        }, 100);
    }

    _this = {
        render: function (liveStatus, liveMap) {
            resetStatus();
            STATUS.liveStatus = liveStatus;
            STATUS.liveMap = liveMap;
            STATUS.$tree = $('<div>').addClass('tree');
            STATUS.$indicatorWrapper = $('<div>').addClass('tree-indicator-wrapper');
            STATUS.$indicator = $('<div>').addClass('tree-indicator');

            if (!STATUS.liveStatus || !STATUS.liveStatus.tournament || !STATUS.liveStatus.tournament.preset || !STATUS.liveStatus.tournament.preset.hasTreeView) {
                chmDialog.error(__i18n('error/somethingWentWrong'));
                return;
            }

            renderColumns().then($columns => {
                STATUS.$tree.append($columns);
                STATUS.$wrapper = $('<div>').addClass('tree-wrapper').on('scroll', updateIndicator).append(STATUS.$tree);

                addEventListeners();

                // TODO add +/- to title

                STATUS.dialog = chmDialog({
                    title: `<div class="row-center row-between text-no-select pl-medium"><span><i class="fa-kit fa-tournament-tree"></i> <span class="color-blue">${__escapeHTML(STATUS.liveStatus.tournament.title)}</span></span><span class="button button-invisible button-small button-square" data-trigger-action="treeView.close"><i class="fa-regular fa-times"></i></span></div>`,
                    content: $('<div>').addClass('tree-container').append(
                        STATUS.$wrapper,
                        STATUS.$indicatorWrapper.append(STATUS.$indicator)
                    ),
                    buttons: [
                        {
                            label: `<span class="color-white"><i class="fa-regular fa-magnifying-glass-plus"></i></span>`,
                            action: function () {
                                ScoreTrekBattle.Event.trigger('action.treeView.zoom', [{}, 'plus']);
                                return false;
                            }
                        },
                        {
                            label: `<span class="color-white"><i class="fa-regular fa-magnifying-glass-minus"></i></span>`,
                            action: function () {
                                ScoreTrekBattle.Event.trigger('action.treeView.zoom', [{}, 'minus']);
                                return false;
                            }
                        }
                    ],
                    paddingTitle: false,
                    forceWidth: true,
                    forceHeight: true,
                    fixedHeight: true,
                    isPersistant: true,
                    overflow: true,
                    onShow: onShow,
                    afterClose: onClose,
                    onResize: onResize
                });
            });
        }
    };

    $(document).on('mouseup', function(event) {
        if (!STATUS.drag.isActive) {
            return;
        }

        stopDrag();
    });

    $(document).on('keydown', function (event) {
        let cx, cy;

        if (!STATUS.$tree) {
            return;
        }

        // + 43, 107, 187
        // - 45, 109, 189
        // ← 37
        // → 39
        // ↑ 38 
        // ↓ 40

        if ([37, 38, 39, 40, 43, 45, 107, 109, 187, 189].indexOf(event.which) === -1) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        if ([43, 107, 187].indexOf(event.which) >= 0) { // +
            cx = STATUS.$wrapper.get(0).clientWidth / 2;
            cy = STATUS.$wrapper.get(0).clientHeight / 2;
            zoomAt(cx, cy, STATUS.zoom.current + 0.1);
        } else if ([45, 109, 189].indexOf(event.which) >= 0) { // -
            cx = STATUS.$wrapper.get(0).clientWidth / 2;
            cy = STATUS.$wrapper.get(0).clientHeight / 2;
            zoomAt(cx, cy, STATUS.zoom.current - 0.1);
        } else if ([37].indexOf(event.which) >= 0) { // left
            STATUS.$wrapper.scrollLeft(STATUS.$wrapper.scrollLeft() - STATUS.pan.step);
        } else if ([39].indexOf(event.which) >= 0) { // right
            STATUS.$wrapper.scrollLeft(STATUS.$wrapper.scrollLeft() + STATUS.pan.step);
        } else if ([38].indexOf(event.which) >= 0) { // up
            STATUS.$wrapper.scrollTop(STATUS.$wrapper.scrollTop() - STATUS.pan.step);
        } else if ([40].indexOf(event.which) >= 0) { // down
            STATUS.$wrapper.scrollTop(STATUS.$wrapper.scrollTop() + STATUS.pan.step);
        }
    });

    ScoreTrekBattle.Event.on('action.treeView.close', function(event) {
        if (STATUS.dialog) {
            STATUS.dialog.close();
        }
    });

    ScoreTrekBattle.Event.on('action.treeView.zoom', function(event, direction) {
        let diff, cx, cy;

        if (!STATUS.$tree) {
            return;
        }

        if (direction === 'reset') {
            STATUS.zoom.current = 1;
            setZoom();
            return;
        }

        diff = (direction === 'plus') ? 0.1 : -0.1;

        cx = STATUS.$wrapper.get(0).clientWidth / 2;
        cy = STATUS.$wrapper.get(0).clientHeight / 2;
        zoomAt(cx, cy, STATUS.zoom.current + diff);
    });

    ScoreTrekBattle.Event.on('action.tree.match.mark', function(event) {
        let gameId;

        gameId = this.dataset.gameId;

        if (!gameId) {
            unmarkGames();
            return;
        }

        markGame(gameId);
    });

    return _this;
})();
